import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStockHistory(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/inventory/stock-history', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStockHistoryForDownload(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/inventory/stock-history/for/download', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
